import BurgerMenu from "@components/BurgerMenu/BurgerMenu"
import CTALink from "@components/elements/CTALink"
import PhoneIcon from "@components/icons/PhoneIcon"
import SearchIcon from "@components/icons/SearchIcon"
import WhatsAppIcon from "@components/icons/WhatsAppIcon"
import useBrandInfo from "@hooks/dataHooks/useBrandInfo"
import useHasScrolled from "@hooks/useHasScrolled"
import logoWhite from "@images/logo-white.svg"
import logo from "@images/logo.svg"
import { listYourPropertyURL, propertiesSaleURL } from "@lib/urls"
import { getWhatsAppURL, gtagReportConversion } from "@lib/utils"
import clsx from "clsx"
import { Link, graphql, useStaticQuery } from "gatsby"
import { isEmpty } from "lodash"
import React, { useEffect, useState, useRef } from "react"
import { Container } from "react-bootstrap"
import "./Header.scss"
import { useGlobalStore } from "@stores/globalStore"
import { CurrencyTypeSelect, LanguageTypeSelect } from "../SearchResults/SearchFilters/filterElements"
import SizeTypeSelector from "@components/SizeTypeSelector/SizeTypeSelector"
import MobileIcon from "@components/icons/MobileIcon"
import useDeviceMedia from "@hooks/useDeviceMedia"
import WhatsAppIconWhite from "@components/icons/WhatsAppIconWhite"
import { getUser, isAuthenticated } from "@starberry/myaccount-website-utils"
import UserIcon from "../icons/UserIcon"
import GGFXImage from "@components/elements/GGFXImage"
import ArrowRight from "@components/icons/ArrowRight"
import { capitalize } from "lodash"
import UserIconLogged from "@components/icons/UserIconLogged"
import GoogleOneTap from "@components/GoogleOneTap/GoogleOneTap"
// import { isMobileOnly } from "react-device-detect"
// import useGoogleTranslateScript from "@components/Translation/BasicTranslation"

const Header = ({ transparentHeader }) => {
  // useGoogleTranslateScript()
  const userData = getUser();
  const authUser = isAuthenticated();
  const [login, setlogin] = useState(false)
  useEffect(() => {
    setlogin(isAuthenticated())
  },[isAuthenticated])
  const { currencyType, language, setSpotlight} = useGlobalStore()
  const [tog, setTog] = useState(false)
  const openToggle = () => {
    setTog(!tog)
    setShowModal(false)

  }
  const isMobile = useDeviceMedia()
  useEffect(() => {
    setTog(false)
  }, [currencyType, language])
  const { phone, whatsapp } = useBrandInfo()
  const scrolled = useHasScrolled()

  const [showModal, setShowModal] = useState(false)

  const data = useStaticQuery(graphql`
    query {
      strapiGlobalMenu {
        header_links {
          id
          content_cta {
            ...contentCtaFragment
          }
          main_menu {
            ...ctaFragment
          }
          sub_menu_cta {
            ...ctaFragmentImage
          }
          sub_menu_bottom {
            ...ctaFragment
          }
          sub_menu_title
          sub_menu_bot_title
          isoffplan
          ismegamenu
          top_title
          isspotlight
        }
        ggfx_results {
          ...STRAPI_GGFX_RESULTFragment
        }
        strapi_id
      }
    }
  `)

  const { header_links, ggfx_results, strapi_id } = data.strapiGlobalMenu
  const isTransparent = transparentHeader && !showModal && !scrolled
  const transparentScroll = transparentHeader && scrolled
  const wrapperRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setTog(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  useEffect(() => {
    setSpotlight(data?.strapiGlobalMenu)
  }, [data?.strapiGlobalMenu])
  const trackSpot = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "Spotlight",
      formType: `Spotlight`,
    })
  }

  return (
    <div
      className={clsx(
        "header-wrap",
        isTransparent && "header-transparent",
        transparentScroll && "transparent-scrolled"
      )}
    >

      <Container className="header">
        <Link to="/" className="logo">
          <img onContextMenu={(e) => e.preventDefault()} draggable="false" src={isTransparent ? logoWhite : logo} alt="Provident Estate" />
        </Link>
        <div className="nav-menu-section">
          {!isEmpty(header_links) &&
            header_links.map((item, mainindex) => {
              const { main_menu, sub_menu_cta, id, content_cta, sub_menu_bottom } = item
              return (
                <div className="nav-menu nav-menu-list" key={id}>
                  <CTALink
                    key={main_menu.id}
                    cta={main_menu}
                    className="main-menu"
                    alsoLabel
                    // reload={mainindex <= 2 ? true: false}
                  />
                  {item?.ismegamenu && (
                  <div className="sub-menu-wrap">
                    <div className="sub-menu-section">
                      <div className="menu-section-only">

                      {item?.isoffplan && item?.top_title && <p className="h4">{item.top_title}</p>}
                      {item?.ismegamenu && (
                        <div className={item?.isoffplan ? "sub-menu offplan" : "sub-menu"} key={sub_menu_cta.id}>
                         {item?.sub_menu_title && <p className="heading">{item.sub_menu_title}</p>}

                          <div className="sub-menu-list">
                            {sub_menu_cta.map((cta) => {
                              return (
                                <CTALink
                                  key={cta.id}
                                  cta={cta}
                                  className="sub-menu-link"
                                  // reload={cta?.custom_link && mainindex <= 3 ? true: false}
                                >
                                 {cta?.image?.url &&
                                //  <img onContextMenu={(e) => e.preventDefault()} draggable="false" src={cta?.image?.url?.replace(process.env.GATSBY_GGFX_S3_HOST, process.env.GATSBY_GGFX_CDN_HOST)}  alt="icons" />
                                //   <>
                                //   <img onContextMenu={(e) => e.preventDefault()} draggable="false" src={`/images/menu_icons/${cta?.cta_label}_icon.jpg`}  alt="icons" />
                                //  </>
                                 <GGFXImage
                                 ImageSrc={cta?.image}
                                 altText="banner-bg"
                                 imagetransforms={ggfx_results}
                                 renderer="srcSet"
                                 imagename={"global-menu.cta.image"}
                                 strapiID={strapi_id}
                                 lazyLoading={false}
                               />
                               } {cta?.cta_label}
                                </CTALink>)
                            })}
                          </div>

                        </div>
                      )}
                       {!isEmpty(sub_menu_bottom) && (
                        <div className={item?.isoffplan ? "sub-menu offplan bt" : "sub-menu"} key={sub_menu_cta.id}>
                          {item.sub_menu_bot_title && <p className="heading">{item.sub_menu_bot_title}</p>}

                          <div className="sub-menu-list">
                            {sub_menu_bottom.map((cta) => {
                              return (
                                <CTALink
                                  key={cta.id}
                                  cta={cta}
                                  className="sub-menu-link"
                                  // reload={cta?.custom_link && mainindex <= 2 ? true: false}
                                > 
                                {cta?.image?.url &&
                                // <img onContextMenu={(e) => e.preventDefault()} draggable="false" src={cta?.image?.url?.replace(process.env.GATSBY_GGFX_S3_HOST, process.env.GATSBY_GGFX_CDN_HOST)}  alt="icons" />

                                // <img onContextMenu={(e) => e.preventDefault()} draggable="false" src={`/images/menu_icons/${cta?.cta_label}_icon.jpg`}  alt="icons" />
                                <GGFXImage
                              ImageSrc={cta?.image}
                              altText="banner-bg"
                              imagetransforms={ggfx_results}
                              renderer="srcSet"
                              imagename={"global-menu.cta.image"}
                              strapiID={strapi_id}
                              lazyLoading={false}
                            />
                                } {cta?.cta_label}
                                </CTALink>)
                            })}
                          </div>

                        </div>
                      )}
                      </div>

                      {!isEmpty(content_cta) && item?.isoffplan ? (
                        <>
                        {content_cta?.image &&
                          <div className="divider" />}
                          {content_cta?.image &&
                          <div className="content-cta-section sub-menu offplan">
                            <div className="image-bg">
                              <GGFXImage
                              ImageSrc={content_cta?.image}
                              altText="banner-bg"
                              imagetransforms={ggfx_results}
                              renderer="srcSet"
                              imagename={"global-menu.content_cta.image"}
                              strapiID={strapi_id}
                              lazyLoading={false}
                            />
                              {/* <img onContextMenu={(e) => e.preventDefault()} draggable="false" src={`/images/menu_icons/${content_cta?.title}_img.jpg`}  alt="icons" /> */}

                              <div className="content">
                                <p className="heading">{content_cta.title}</p>
                                {content_cta.description &&<p className="description">
                                  {content_cta.description}
                                </p>}
                                <CTALink
                                  cta={content_cta.cta}
                                  className="button button-orange"
                                  onClick={()=> {
                                    item.isspotlight ? trackSpot() : null
                                  }}
                                  istrackSpot={item.isspotlight ? true : false}

                                />
                              </div>
                            </div>

                          </div>}
                        </>
                      ) : !isEmpty(content_cta) ?
                        <div className="mega-menu">
                          {content_cta?.title && content_cta.description && <div className="content">
                            {content_cta?.title && <p className="heading">{content_cta?.title}</p>}
                            {content_cta.description && <div className="para">
                              {content_cta.description}
                            </div>}
                            <div className="cta-section">
                              {content_cta?.ctas?.map((cta, index) => {

                                return (

                                  <CTALink
                                    cta={cta}
                                    key={cta.id}
                                    className={clsx(
                                      "button",
                                      index === 0 ? "button-orange" : "button-blue"
                                    )}
                                  />
                                )
                              })}
                            </div>
                          </div>}
                          {content_cta?.image &&
                          <div className="gap-line" />}
                          {content_cta?.image &&
                          <div className="image">
                            <div>
                              <CTALink cta={content_cta?.cta} className="open-link">
                                <GGFXImage
                                ImageSrc={content_cta?.image}
                                altText="banner-bg"
                                imagetransforms={ggfx_results}
                                renderer="srcSet"
                                imagename={"global-menu.content_cta.image1"}
                                strapiID={strapi_id}
                                lazyLoading={false}
                              />
                              {/* <img onContextMenu={(e) => e.preventDefault()} draggable="false" src={`/images/menu_icons/${content_cta?.title}_img.jpg`}  alt="icons" /> */}
                              </CTALink>
                              <CTALink cta={content_cta?.cta} className="link-title">
                                <span>{content_cta?.cta?.cta_label}</span>
                                <ArrowRight color="white" />
                              </CTALink>
                            </div>
                          </div>}
                        </div>
                        : null
                      }
                    </div>
                  </div>
                  )} 
                </div>
              )
            })}
          <div ref={wrapperRef} className="dev-to d-none d-md-block">
            <div className="dev-toggle" onClick={() => openToggle()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.4107 11.1607L16.4652 10.2152C16.3226 10.0726 16.2041 9.90811 16.1139 9.72785L15.2139 7.92775C15.1087 7.71732 14.8282 7.6718 14.6618 7.83817C14.4848 8.0152 14.2257 8.08234 13.985 8.01356L12.9242 7.71049C12.5214 7.59539 12.1033 7.83687 12.0017 8.24333C11.9257 8.54718 12.049 8.86597 12.3095 9.0397L12.7985 9.36566C13.2907 9.69383 13.3597 10.3903 12.9414 10.8086L12.7746 10.9754C12.5988 11.1512 12.5 11.3897 12.5 11.6383V11.9807C12.5 12.3205 12.4076 12.6539 12.2328 12.9453L11.1373 14.7712C10.8195 15.3009 10.247 15.625 9.6293 15.625C9.14368 15.625 8.75 15.2313 8.75 14.7457V13.7694C8.75 13.0027 8.28322 12.3133 7.57136 12.0285L7.02624 11.8105C6.20812 11.4832 5.72825 10.6305 5.87311 9.76135L5.87897 9.72616C5.91765 9.49413 5.99964 9.27144 6.12066 9.06973L6.19517 8.94555C6.60286 8.26607 7.39368 7.91624 8.17069 8.07164L9.15223 8.26795C9.63113 8.36373 10.1033 8.0758 10.2375 7.6062L10.4113 6.99812C10.5352 6.56434 10.3326 6.1038 9.92909 5.90204L9.375 5.625L9.29917 5.70083C8.94754 6.05246 8.47063 6.25 7.97335 6.25H7.82258C7.61603 6.25 7.41746 6.33254 7.27141 6.47859C7.03519 6.71481 6.67345 6.77423 6.37465 6.62483C5.97027 6.42264 5.82361 5.91899 6.05622 5.53131L7.2328 3.57033C7.3502 3.37467 7.43041 3.16006 7.47044 2.93728M17.4107 11.1607C17.4695 10.7824 17.5 10.3948 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C9.11236 2.5 8.26073 2.6542 7.47044 2.93728M17.4107 11.1607C16.8528 14.7517 13.7474 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 6.74551 4.57291 3.97517 7.47044 2.93728"
                  stroke="#9399A4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className={tog ? "active" : ""}>
                {currencyType?.value}
              </span>
              {tog ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M3 10.5L8 5.5L13 10.5"
                    stroke="#9399A4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M13 5.5L8 10.5L3 5.5"
                    stroke="#9399A4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>
            {tog && (
              <div className="dev-to-open">
                <div className="label">Currency</div>
                <CurrencyTypeSelect setTog={setTog} tog={tog} />
                <SizeTypeSelector setTog={setTog} tog={tog} />
                <div className="mt-3"></div>
              </div>
            )}
          </div>
          {isAuthenticated() ?
           <Link to={process.env.GATSBY_MYACCOUNT_URL} className="my-account-user d-none d-xl-block">
           <UserIconLogged
             className="user-icon"
             color={isTransparent ? "white" :  transparentScroll ? "#07234B" : "#07234B"}
             isAuthenticated={isAuthenticated()}
           />
         </Link> : 
          <div className="d-none  d-xl-flex log-in-btn">
          <Link to={process.env.GATSBY_MYACCOUNT_URL} className={clsx(
                "button list-prop-btn",
                isTransparent ? "button-white-outline" : "button-white"
              )}>
                    <UserIcon
                    className={clsx(
                      "user-icon",
                      isAuthenticated() ? "stoke" : ""
                    )}
                      color={isTransparent ? "white" :  transparentScroll ? "#07234B" : "#07234B"}
                      isAuthenticated={isAuthenticated()}
                    />
                   {isAuthenticated() ? "" : "Login"}
                  </Link></div>}
                  {(!authUser) && (
                  <GoogleOneTap />
                  )}
          <div className="nav-menu d-xl-flex d-md-none nav-menu-property-list-button">
            <Link
              to={listYourPropertyURL}
              className={clsx(
                "button list-prop-btn",
                isTransparent ? "button-white-outline" : "button-white"
              )}
            >
              List Your Property
            </Link>
          </div>

          <Link
            // href={getWhatsAppURL(whatsapp)}
            className="nav-menu nav-menu-icon-wrap"
            aria-label="WhatsApp Us"
            id="openbot"
          >
            {
              isMobile ? <WhatsAppIconWhite className="menu-icon" color={isTransparent ? "white" : "#67C15E"} /> :
                <WhatsAppIcon className="menu-icon" />}
          </Link>
          <a
            href={`tel:${phone}`}
            onClick={() => gtagReportConversion(`tel:${phone}`)}
            className="nav-menu nav-menu-icon-wrap"
            aria-label="Call Us"
          >
            {
              isMobile ?
                <PhoneIcon className="menu-icon"
                  color={isTransparent ? "white" : "blue"}
                />
                :
                <MobileIcon
                  className="menu-icon"
                  color={isTransparent ? "white" : "blue"}
                  ismob
                />

            }

          </a>
          <Link
            to={propertiesSaleURL}
            className="nav-menu nav-menu-icon-wrap"
            aria-label="Search Properties"
          >
            <SearchIcon
              className="menu-icon"
              color={isTransparent && "white"}
            />
          </Link>
          <BurgerMenu
            links={header_links}
            whiteIcon={isTransparent}
            showModal={showModal}
            setShowModal={setShowModal}
            // setTog={setTog}
            propssetTog={setTog}
            top={tog}
            isTransparent={isTransparent}
            transparentScroll={transparentScroll}
            isAuthenticated={isAuthenticated()}
          />
        </div>
      </Container>
    </div>
  )
}

export default Header